import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
	container:{
		marginTop: '20px',
	},
	gridPrincipal:{
		width: '100%', 
		position: 'relative', 
		overflow: 'auto', 
		border: '1px solid  #cccccc', 
		borderRadius: '20px', 
		marginBottom:10,		
	},
	gridIframe :{
		height: '80vh',
	}	
}))